export enum GetCoordinationsResultType {
    Unknown = 'An unknown error has occurred while fetching the DataMiner Systems.',
    OrganizationNotFound = 'The organization could no longer be found.',
    Timeout = 'The DataMiner Systems could not be loaded because the request took too long.'
}
